export enum TelemetryUnitOfMeasure {
  acre = "acre",
  ampere = "ampere",
  astronomicalUnit = "astronomicalUnit",
  bar = "bar",
  bel = "bel",
  bit = "bit",
  bitPerSecond = "bitPerSecond",
  byte = "byte",
  bytePerSecond = "bytePerSecond",
  candela = "candela",
  candelaPerSquareMetre = "candelaPerSquareMetre",
  centimetre = "centimetre",
  centimetrePerSecond = "centimetrePerSecond",
  centimetrePerSecondSquared = "centimetrePerSecondSquared",
  coulomb = "coulomb",
  cubicCentimetre = "cubicCentimetre",
  cubicFoot = "cubicFoot",
  cubicInch = "cubicInch",
  cubicMetre = "cubicMetre",
  day = "day",
  decibel = "decibel",
  degreeCelsius = "degreeCelsius",
  degreeFahrenheit = "degreeFahrenheit",
  degreeOfArc = "degreeOfArc",
  degreePerSecond = "degreePerSecond",
  electronvolt = "electronvolt",
  exbibit = "exbibit",
  exbibitPerSecond = "exbibitPerSecond",
  exbibyte = "exbibyte",
  exbibytePerSecond = "exbibytePerSecond",
  farad = "farad",
  fluidOunce = "fluidOunce",
  foot = "foot",
  footcandle = "footcandle",
  gallon = "gallon",
  gForce = "gForce",
  gibibit = "gibibit",
  gibibitPerSecond = "gibibitPerSecond",
  gibibyte = "gibibyte",
  gibibytePerSecond = "gibibytePerSecond",
  gigahertz = "gigahertz",
  gigajoule = "gigajoule",
  gigawatt = "gigawatt",
  gram = "gram",
  gramPerCubicMetre = "gramPerCubicMetre",
  gramPerHour = "gramPerHour",
  gramPerSecond = "gramPerSecond",
  hectare = "hectare",
  henry = "henry",
  hertz = "hertz",
  horsepower = "horsepower",
  hour = "hour",
  inch = "inch",
  inchesOfMercury = "inchesOfMercury",
  inchesOfWater = "inchesOfWater",
  joule = "joule",
  kelvin = "kelvin",
  kibibit = "kibibit",
  kibibitPerSecond = "kibibitPerSecond",
  kibibyte = "kibibyte",
  kibibytePerSecond = "kibibytePerSecond",
  kilogram = "kilogram",
  kilogramPerCubicMetre = "kilogramPerCubicMetre",
  kilogramPerHour = "kilogramPerHour",
  kilogramPerSecond = "kilogramPerSecond",
  kilohertz = "kilohertz",
  kilojoule = "kilojoule",
  kilometre = "kilometre",
  kilometrePerHour = "kilometrePerHour",
  kilometrePerSecond = "kilometrePerSecond",
  kiloohm = "kiloohm",
  kilopascal = "kilopascal",
  kilova = "kilova",
  kilovar = "kilovar",
  kilovarHour = "kilovarHour",
  kilovolt = "kilovolt",
  kilowatt = "kilowatt",
  kilowattHour = "kilowattHour",
  kilowattHourPerYear = "kilowattHourPerYear",
  knot = "knot",
  kvar = "kvar",
  litre = "litre",
  litrePerHour = "litrePerHour",
  litrePerSecond = "litrePerSecond",
  lumen = "lumen",
  lux = "lux",
  maxwell = "maxwell",
  mebibit = "mebibit",
  mebibitPerSecond = "mebibitPerSecond",
  mebibyte = "mebibyte",
  mebibytePerSecond = "mebibytePerSecond",
  megaelectronvolt = "megaelectronvolt",
  megahertz = "megahertz",
  megajoule = "megajoule",
  megaohm = "megaohm",
  megava = "megava",
  megavar = "megavar",
  megavarHour = "megavarHour",
  megavolt = "megavolt",
  megawatt = "megawatt",
  megawattHour = "megawattHour",
  metre = "metre",
  metrePerHour = "metrePerHour",
  metrePerSecond = "metrePerSecond",
  metrePerSecondSquared = "metrePerSecondSquared",
  microampere = "microampere",
  microfarad = "microfarad",
  microgram = "microgram",
  microhenry = "microhenry",
  micrometre = "micrometre",
  microsecond = "microsecond",
  microvolt = "microvolt",
  microwatt = "microwatt",
  mile = "mile",
  milePerHour = "milePerHour",
  milePerSecond = "milePerSecond",
  milliampere = "milliampere",
  millibar = "millibar",
  millifarad = "millifarad",
  milligram = "milligram",
  millihenry = "millihenry",
  millilitre = "millilitre",
  millilitrePerHour = "millilitrePerHour",
  millilitrePerSecond = "millilitrePerSecond",
  millimetre = "millimetre",
  millimetresOfMercury = "millimetresOfMercury",
  milliohm = "milliohm",
  millisecond = "millisecond",
  millivolt = "millivolt",
  milliwatt = "milliwatt",
  minute = "minute",
  minuteOfArc = "minuteOfArc",
  nanofarad = "nanofarad",
  nanometre = "nanometre",
  nanosecond = "nanosecond",
  nauticalMile = "nauticalMile",
  newton = "newton",
  newtonMetre = "newtonMetre",
  ohm = "ohm",
  ounce = "ounce",
  pascal = "pascal",
  percent = "percent",
  picofarad = "picofarad",
  pound = "pound",
  poundPerSquareInch = "poundPerSquareInch",
  radian = "radian",
  radianPerSecond = "radianPerSecond",
  radianPerSecondSquared = "radianPerSecondSquared",
  revolutionPerMinute = "revolutionPerMinute",
  revolutionPerSecond = "revolutionPerSecond",
  second = "second",
  secondOfArc = "secondOfArc",
  slug = "slug",
  squareCentimetre = "squareCentimetre",
  squareFoot = "squareFoot",
  squareInch = "squareInch",
  squareKilometre = "squareKilometre",
  squareMetre = "squareMetre",
  squareMillimetre = "squareMillimetre",
  tebibit = "tebibit",
  tebibitPerSecond = "tebibitPerSecond",
  tebibyte = "tebibyte",
  tebibytePerSecond = "tebibytePerSecond",
  tesla = "tesla",
  ton = "ton",
  tonne = "tonne",
  turn = "turn",
  va = "va",
  var = "var",
  varHour = "kilovarHour",
  volt = "volt",
  watt = "watt",
  weber = "weber",
  year = "year",
  yobibit = "yobibit",
  yobibitPerSecond = "yobibitPerSecond",
  yobibyte = "yobibyte",
  yobibytePerSecond = "yobibytePerSecond",
  zebibit = "zebibit",
  zebibitPerSecond = "zebibitPerSecond",
  zebibyte = "zebibyte",
  zebibytePerSecond = "zebibytePerSecond"
}
